module.exports = __webpack_public_path__ + "img/nagasakidai_logo.8a3c62f1.jpg";